import React, { useState } from "react";
import { IonSpinner } from "@ionic/react";
import { Icon_Tick_Blue } from "@assets/images";
import * as ProgramUtils from "@utils/programUtils";
import { format } from "date-fns";

type SendState = "idle" | "sending" | "sent";

interface ResendEvidenceButtonProps {
  onResend: () => Promise<void>;
  programID?: string;
  isExpired?: boolean;
  expiryDate: string;
}

const ResendEvidenceButton: React.FC<ResendEvidenceButtonProps> = (props) => {
  const headerText = props.isExpired ? "Evidence request has expired" : "Evidence request is pending approval";
  const [sendState, setSendState] = useState<SendState>("idle");

  const handleResend = async () => {
    if (sendState !== "idle") return;
    setSendState("sending");

    try {
      await props.onResend();
      setSendState("sent");
    } catch {
      setSendState("idle");
    }
  };

  return (
    <div className="readEvidenceBlock !mt-0 mb-4">
      <div className="flex flex-row items-center justify-between">
        <div className="flex flex-col gap-1">
          <div className="readEvidenceHeader !mb-0">{headerText}</div>
          <div className="text-13px font-semibold leading-default tracking-default text-grey-70">{`${ProgramUtils.getResendEvidenceSubtitle(props.programID)} ${props.isExpired ? "expired on" : "expires on"} ${format(new Date(props.expiryDate), "dd MMM yyyy")}`}</div>
        </div>
        <button
          onClick={handleResend}
          disabled={sendState !== "idle"}
          className="ml-4 flex !min-h-[33px] min-w-[72px] flex-shrink-0 items-center justify-center rounded-[4px] bg-grey-20 px-3 py-1.5 text-acc-14px font-semibold text-cta-blue disabled:opacity-60"
        >
          {sendState === "sending" && <IonSpinner className="h-[18px] w-[18px] text-cta-blue" />}
          {sendState === "sent" && (
            <div className="flex flex-row items-center gap-1">
              <img
                src={Icon_Tick_Blue}
                className="h-[14px] w-[14px]"
              />
              <span>{"Sent"}</span>
            </div>
          )}
          {sendState === "idle" && <span>{ProgramUtils.resendEvidenceText()}</span>}
        </button>
      </div>
    </div>
  );
};

export default ResendEvidenceButton;
